import { mapState } from 'vuex';
import store from '@/store';

export default {
  data() {
    return {
      loadingCustomer: 0,
      customer: {},
    };
  },

  computed: {
    userInfo() {
      return (this.user && this.user.info) || null;
    },
    authenticated() {
      return (this.user && this.user.authenticated) || false;
    },
    ...mapState({
      user: state => state.user,
      authenticating: state => state.user.authenticating,
    }),
  },
  beforeRouteEnter(to, from, next) {
    if (!store.state.user.authenticated) {
      store.commit('queueRoute', to.path);
      next('/login');
      return;
    }
    store.commit('queueRoute', '/');
    next();
  },
};
